import { registerDriver } from "../../driverRegistry";
import { BraintreeProvider } from "./BraintreeProvider";
import { BraintreeCardDetails } from "./BraintreeCardDetails";
import { BraintreeCreditCardButton } from "./BraintreeCreditCardButton";
import { BraintreeApplePayButton } from "./BraintreeApplePayButton";
import { BraintreeGooglePayButton } from "./BraintreeGooglePayButton";
import { BraintreePayPalButton } from "./BraintreePayPalButton";

registerDriver("braintree", {
  Provider: BraintreeProvider,
  CardDetails: BraintreeCardDetails,
  CreditCardButton: BraintreeCreditCardButton,
  ApplePayButton: BraintreeApplePayButton,
  GooglePayButton: BraintreeGooglePayButton,
  PayPalButton: BraintreePayPalButton,
});
